module.exports = __webpack_public_path__ + "img/AK.9f130d98.png";